exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Toolbar___CuJgF {\n  height: 2.25rem;\n  padding: 0 0.5rem;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.Content___2tGS0 {\n  padding: 0.5rem;\n  user-select: none;\n  overflow: auto;\n}\n\n.List___2AC9R {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.ListItem___2wzT0 {\n  margin: 0 0 0.5rem;\n}\n\n.Label___3KINM {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: bold;\n}\n\n.Value___3wrFP {\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n}\n\n.NothingSelected___2Sj9L {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: var(--color-dim);\n}\n\n.DurationsList___19XUj {\n  list-style: none;\n  margin: 0.25rem 0 0 0;\n  padding: 0;\n  background: var(--color-background-inactive);\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n}\n\n.DurationsListItem___2UKVV {\n  margin: 0.25rem 0 0 0;\n}\n.DurationsListItem___2UKVV:first-of-type {\n  margin: 0;\n}\n", ""]);

// exports
exports.locals = {
	"Toolbar": "Toolbar___CuJgF",
	"Content": "Content___2tGS0",
	"List": "List___2AC9R",
	"ListItem": "ListItem___2wzT0",
	"Label": "Label___3KINM",
	"Value": "Value___3wrFP",
	"NothingSelected": "NothingSelected___2Sj9L",
	"DurationsList": "DurationsList___19XUj",
	"DurationsListItem": "DurationsListItem___2UKVV"
};